<template>
  <div class="widget" style="z-index: 1">
    <div class="widget-label">
      <div class="label">
        <p>Potential Risks</p>
      </div>
    </div>
    <div class="widget-content">
      <b-row v-if="accountUser.admin == true">
        <b-col cols="12">
          <div 
            v-if="isKickoffOpen"
            class="mb-2 custom-search dark position-relative"
          >
            <b-form @submit.prevent="onAddRiskSubmit">
              <b-form-group label="Add a risk" label-for="risk-name">
                <div class="d-flex">
                  <b-form-input
                    id="risk-name"
                    v-model="form.name"
                    maxlength="500"
                    @blur="onRiskFormBlur"
                  ></b-form-input>
                  <b-button
                    type="submit"
                    :disabled="sending || form.name.length === 0"
                  >
                    <b-spinner v-if="sending" small label="Spinning" />
                    <div v-else>Add</div>
                  </b-button>
                </div>
              </b-form-group>
            </b-form>
            <BaseMessageBlock :messages="errors"></BaseMessageBlock>
          </div>
          <div 
            v-if="risks.length > 0"
            class="d-flex"
          >
            <b-badge 
              v-for="risk in risks"
              :key="risk"
              variant="secondary"
              class="mr-1 badge-tag"
              style="font-size: var(--body-p);"
            >
              <span class="d-inline-block py-2">{{ risk }}</span>
              <b-button 
                v-if="isKickoffOpen && accountUser.admin == true"
                variant="link" 
                class="btn-delete text-white pr-0 text-decoration-none"
                @click="showDeleteConfirmation(risk)"
              >
                &times;<span class="sr-only"> Delete</span>
              </b-button>
            </b-badge>
          </div>
          <p 
            v-else
            class="text-center mt-3"
          >
            {{
              isKickoffOpen
                ? (emptyText = "Add a risk!")
                : (emptyText = "No Risks for this meeting")
            }}
          </p>
        </b-col>
      </b-row>
    </div>
    <BaseConfirmationModal
      ref="del-risk-confirmation"
      title="Delete Risk"
      :message="deletingRiskMessage"
      okText="Delete"
      @submit="onDeleteRiskConfirm"
      @cancel="cancelDelete"
    ></BaseConfirmationModal>
  </div>
</template>

<script>
import axios from "axios";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";
import pmMixin from "@/mixins/project-metric-mixin.js";
// import { utc } from "moment";

export default {
  name: "KickoffRisks",
  components: {
    BaseConfirmationModal,
  },
  mixins: {
    pmMixin,
  },
  props: {
    projectId: {
      type: String,
      default: "",
    },
    status: {
      type: String,
    },
    meetingId: {
      type: String,
      default: "",
    },
    presetTags: { 
      type: Array, 
      // default: () => []
      required: true 
    },
  },
  data() {
    return {
      errors: [],
      form: {
        name: ''
      },
      deletingRiskId: "",
      deletingRiskMessage: "",
      editingRiskId: "",
      sending: false,
      showModal: false,
      allUsersName: [],
      starFill: "star-fill",
      starEmpty: "star",
      testArray: [],
      emptyText: "No Risks To Show!",
      user: "",
      // risks: [],
      tableColumns: ['name'],
      // isSendingCharter: false,
      // allRisksUI: this.risks,
    };
  },
  computed: {
    isKickoffOpen() {
      return this.status === "Open";
    },
    risks: {
      get() {
        return this.presetTags;
      },
      set(v) {
      }
    }
  },
  // watch: {
  //   presetTags(tags) {
  //     console.log('presetTags updated');
  //     this.risks = tags;
  //   }
  // },
  mounted() {
    // this.loadRisks();
    // this.risks = presetTags;
  },
  methods: {
    show() {
      return (this.showModal = true);
    },
    hide() {
      return (this.showModal = false);
    },
    cancel() {
      this.reset();
      this.hide();
    },
    reset() {
      // this.form = this.newForm();
      this.deletingRiskId = "";
      this.deletingRiskMessage = "";
      this.editingRiskId = "";
      this.sending = false;
    },
    onRiskFormBlur() {
      if (this.form.name.trim().length === 0) {
        this.errors = [];
      }
    },
    // loadRisks() {
    //   axios
    //     .get(
    //       `${this.$api_url}/risks/${this.projectId}`,
    //       this.getReqConfig()
    //     )
    //     .then((response) => {
    //       this.risks = response.data;
    //     })
    //     .catch(() => {
    //     })
    //     .finally(() => {
    //     });
    // },
    validateRisk(risk){
      const initErrors = this.errors.length;
      let name = risk;

      if (!name.length) {
        this.errors.push({message: 'Risk name cannot be empty' })
      } else if (this.risks.find(r => r.trim().toLowerCase() === name.toLowerCase())){
        this.errors.push({
          message: `Risk "${name}" is already part of this project`
        });
      }

      return initErrors === this.errors.length;
    },
    onAddRiskSubmit() {
      if (this.form.name.trim().length === 0) {
        return;
      }
      // var guidRiskId = this.$helpers.generateUUID();
      // let risk = {
      //   // riskId: this.$helpers.generateUUID(),
      //   // projectId: this.projectId,
      //   name: this.form.name,
      //   // desc: '',
      //   // meetingId: this.meetingId,
      //   // dateCreated: new Date(),
      //   // favorited: false,
      //   // riskHidden: false,
      //   // deleted: false,
      //   // userId: this.accountUser.userId,
      //   // userName: this.accountUser.name,
      // };

      let risk = this.form.name.trim();

      if (!this.validateRisk(risk)) {
        return;
      }
      
      this.risks.push(risk);
      this.risks.sort();
      const risksList = this.risks.join(',');

      let request = {
        projectId: this.projectId,
        presetTags: risksList,
      }

      // let newRisk = {
      //   riskId: guidRiskId,
      //   // meetingId: this.meetingId,
      //   // dateCreated: new Date(),
      //   risk: this.form.name,
      //   // favorited: false,
      //   // riskHidden: false,
      //   // deleted: false,
      //   // userId: this.accountUser.userId,
      //   // userName: this.accountUser.name,
      //   // editing: false,
      //   // sending: false,
      //   // newContent: "",
      // };

      this.sending = true;

      axios
        .put(
          `${this.$api_url}/project/tags/update`,
          request,
          this.getReqConfig()
        )
        .then(() => {
          console.log('successfully added risk');
          // this.form = this.newForm();
          this.form.name = "";
          this.errors = [];
          // this.$emit("refresh", this.meetingId);
        })
        .catch(() => {
          //Do something about it
        })
        .finally(() => {
          this.sending = false;
          this.$emit("refresh", this.meetingId);
        });
      // this.risks.unshift(newRisk);
      // this.form.name = "";
      // this.sending = false;
      // this.risks = this.risks.sort((a, b) =>
      //   a.dateCreated > b.dateCreated ? -1 : 1
      // );
    },
    newForm() {
      return {
        riskId: null,
        meetingId: null,
        dateCreated: null,
        name: "",
        favorited: false,
        riskHidden: false,
        deleted: false,
        userId: null,
        editing: false,
        sending: false,
        newContent: "",
      };
    },
    showDeleteConfirmation(risk) {
      // this.deletingRiskId = riskId;
      this.deletingRiskId = risk;
      this.deletingRiskMessage = `Are you sure you want to delete "${risk}"?`;
      this.$refs["del-risk-confirmation"].show();
    },
    cancelDelete() {
      this.deletingRiskId = "";
    },
    onDeleteRiskConfirm() {

      const deletingRiskIndex = this.risks.indexOf(this.deletingRiskId);
      this.risks.splice(deletingRiskIndex,1);

      const risksList = this.risks.join(',');

      let request = {
        projectId: this.projectId,
        presetTags: risksList,
      }

      axios
        .put(
          `${this.$api_url}/project/tags/update`,
          request,
          this.getReqConfig()
        )
        .then(() => {
          console.log('successfully deleted risk');
          // this.$emit("refresh", this.meetingId);
        })
        .catch(() => {
          // this.risks.find(
          //   (c) => c.riskId === this.deletingRiskId
          // ).sending = false;
        })
        .finally(() => {
          // this.deletingRiskId = "";
        });
      // this.risks.find(
      //   (c) => c.riskId === this.deletingRiskId
      // ).deleted = true;
      // this.risks.find(
      //   (c) => c.riskId === this.deletingRiskId
      // ).sending = false;
      //May need to splice array to make the risks array empty
      //  this.risks.find(
      //   (c) => c.riskId === this.deletingRiskId
      // ).splice(c);
      // this.risks.splice()
    },
    // onEditRiskSubmit(id) {
    //   let risk = this.risks.find((c) => c.riskId === id);

    //   if (risk.newContent === "") {
    //     return;
    //   }

    //   let request = {
    //     riskId: risk.riskId,
    //     lastEdited: new Date(),
    //     risk: risk.newContent,
    //     favorited: risk.favorited,
    //     riskHidden: risk.riskHidden,
    //     userId: risk.userId,
    //     deleted: risk.deleted,
    //   };

    //   risk.sending = true;
    //   risk.name = risk.newContent;
    //   risk.editing = true;
    //   axios
    //     .post(
    //       `${this.$api_url}/meeting/${this.meetingId}/risks/update/${risk.riskId}`,
    //       request,
    //       this.getReqConfig()
    //     )
    //     .then(() => {
    //       this.$emit("refresh", this.meetingId);
    //     })
    //     .catch(() => {
    //       risk.sending = false;
    //     })
    //     .finally(() => {
    //       this.editingRiskId = "";
    //     });
    //   risk.sending = false;
    //   risk.editing = false;
    //   this.editingRiskId = "";
    // },
    // favoriteRisks(riskId) {
    //   let risk = this.risks.find((c) => c.riskId === riskId);

    //   if (risk.name === "") {
    //     return;
    //   }

    //   risk.sending = true;
    //   risk.favorited = risk.favorited === true ? false : true;
    //   axios
    //     .post(
    //       `${this.$api_url}/meeting/risks/${risk.riskId}/favorite/${risk.favorited}`,
    //       null,
    //       this.getReqConfig()
    //     )
    //     .then(() => {
    //       this.$emit("refresh", this.meetingId);
    //     })
    //     .catch(() => {
    //       risk.sending = false;
    //     })
    //     .finally(() => {
    //       this.editingRiskId = "";
    //     });
    //   risk.sending = false;
    //   //this.editingRiskId = "";
    // },
    // showSendCharterModal() {
    //   this.$refs["send-charter-confirmation"].show();
    // },
    // sendCharter() {
    //   this.isSendingCharter = true;
    //   const url = `${this.$api_url}/projects/${this.projectId}/send-charter`;
    //   console.log(url);
    //   axios
    //     .post(
    //       url,
    //       null,
    //       this.getReqConfig()
    //     )
    //     .then(() => {
    //     })
    //     .catch(() => {
    //     })
    //     .finally(() => {
    //       this.isSendingCharter = false;
    //     });
    // },
    // cancelSendCharter() {

    // }
  },
};
</script>


<style lang="scss" scoped>
.custom-search {
  &__modal {
    background: white;
    border-radius: 4px;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: all 0.15s ease-in-out;

    &.open {
      top: 42px;
      opacity: 1;
      height: auto;
      z-index: 2;
    }
  }
  &__result {
    position: absolute;
    height: 100%;
    left: 48px;
    top: 0px;
    display: flex;
    align-items: center;
    pointer-events: none;
    font-size: var(--body-p);
    opacity: 0.2;
    &--left-over {
      background: #90a0b7;
    }
  }
}
.badge-tag {
  .btn-delete {
    display: none;
  }
  &:hover .btn-delete {
    display: inline-block;
  }
}
</style>